import INFRAMARK_CONSTANTS from "common/Constants/inframark-constants";
import { getRequestPAdmin, postRequestPAdmin } from "common/HttpClient/http-utility";

const mapIdentifierExistsResponse = (response) => {
  if (response?.error) {
    return { error: response.error, status: response?.status };
  }
  const body = response?.data;
  const existsFlag = body?.exists ?? body?.data?.exists;
  return {
    status: response?.status,
    exists: existsFlag === true,
  };
};

const mapValidateInviteResponse = (response) => {
  if (response?.error) {
    return { error: response.error, status: response?.status };
  }
  const body = response?.data ?? {};
  return {
    status: response?.status,
    email: String(body.email ?? "").trim(),
    userName: String(body.userName ?? "").trim(),
    requiresSignup: body.requiresSignup === true,
  };
};

export const validateInviteToken = async (token) => {
  const trimmed = String(token ?? "").trim();
  if (!trimmed) {
    return { error: "Invitation token is required." };
  }
  const url = `${INFRAMARK_CONSTANTS.users.services.userInviteValidate}?token=${encodeURIComponent(trimmed)}`;
  const response = await getRequestPAdmin(url);
  return mapValidateInviteResponse(response);
};

export const checkIdentifierExists = async ({ phoneNumber } = {}) => {
  const params = new URLSearchParams();
  const phone = String(phoneNumber ?? "").trim();

  if (!phone) {
    return { exists: false };
  }

  params.set("phoneNumber", phone);

  const basePath = INFRAMARK_CONSTANTS.users.services.userIdentifierExists;
  const url = `${basePath}?${params.toString()}`;
  const response = await getRequestPAdmin(url);
  return mapIdentifierExistsResponse(response);
};

export const postInviteAcceptance = async (payload) => {
  const url = INFRAMARK_CONSTANTS.users.services.inviteAcceptances;
  return postRequestPAdmin(url, payload);
};
